import { Route, Routes } from "react-router-dom";
import { UserRole, logOut } from "../utils/api/endpoints/user/credentials";
import DashboardLayout from "../layouts/DashboardLayout";
import ResearcherRoutes from "./users/ResearcherRoutes";
import AdminRoutes from "./users/AdminRoutes";
import BusinessRoutes from "./users/BusinessRoutes";
import useUserCredentials from "../utils/hooks/user/useUserCredentials";
import PaginatedReports from "../pages/reports/PaginatedReports";
import PaginatedPrograms from "../pages/programs/PaginatedPrograms";
import ProgramPage from "../pages/programs/ProgramPage";
import ReportPage from "../pages/reports/ReportPage";
import RetestManagement from "../pages/retests/RetestManagent";
import RetestPage from "../pages/retests/RetestPage";
import QARoutes from "./users/QARoutes";
import AdminManagerRoutes from "./users/AdminManagerRoutes";
import SubAdminRoutes from "./users/SubAdminRoutes";
import DeveloperRoutes from "./users/DeveloperRoutes";
import BusinessManagerRoutes from "./users/BusinessManagerRoutes";
import BusinessAdminRoutes from "./users/BusinessAdminRoutes";
import SolutionsSpecialistRoutes from "./users/SolutionsSpecialistRoutes";
/**
 * Determines which routes should be available to
 * the user based on their user type
 */
const DashboardRoutes = () => {
  const { role } = useUserCredentials();

  // Determine which routes to support based on user role
  const getUserRoutes = () => {
    switch (role) {
      case UserRole.RESEARCHER:
        return <ResearcherRoutes />;
      case UserRole.BUSINESS:
        return <BusinessRoutes />;
      case UserRole.ADMIN:
        return <AdminRoutes />;
      case UserRole.QA:
        return <QARoutes />;
      case UserRole.ADMIN_MANAGER:
        return <AdminManagerRoutes />;
      case UserRole.SUB_ADMIN:
        return <SubAdminRoutes />;
      case UserRole.DEVELOPER:
        return <DeveloperRoutes />;
      case UserRole.BUSINESS_MANAGER:
        return <BusinessManagerRoutes />;
      case UserRole.BUSINESS_ADMINISTRATOR:
        return <BusinessAdminRoutes />;
      case UserRole.SOLUTIONS_SPECIALIST:
        return <SolutionsSpecialistRoutes />;
      default:
        // Prevent invalid user role
        logOut();
    }
  };

  return (
    <>
      <Routes>
        <Route element={<DashboardLayout />}>
          <Route path="/*" element={getUserRoutes()} />
        </Route>
      </Routes>
    </>
  );
};

export default DashboardRoutes;
